import React, { Component } from 'react';
var Rebase = require('re-base');
import Inner from './Inner';
import Login from './Login';
import Dashboard from './Dashboard';
import './Admin.css';

var base = Rebase.createClass({
  apiKey: "AIzaSyAIpqi8mYkAHxbvSOHCea8izG-62wgibmM",
  authDomain: "georgeotto-8390e.firebaseapp.com",
  databaseURL: "https://georgeotto-8390e.firebaseio.com",
  storageBucket: "georgeotto-8390e.appspot.com",
  messagingSenderId: "410420858322"
});

class Admin extends Component {

	constructor() {
		super();
		this.state = {
			loggedIn: false,
			user: null
		}
	}

	signInUser = (email, password) => {
		base.auth().signInWithEmailAndPassword(email, password).then(function(user) {
			this.setState({
				user: user,
				loggedIn: true
			});
		}.bind(this), function(error) {
			console.log(error);
		});
	}
    
  render() {
  	let content;
  	if (!this.state.loggedIn) {
  		content = <Login signIn={this.signInUser} />;
  	} else {
  		content = <Dashboard base={base}/>;
  	}


      return(
          <Inner title={this.state.loggedIn ? 'Admin' : 'Login'}>
          	{ content }
          </Inner>
      );
  }
}

export default Admin;


// WEBPACK FOOTER //
// ./src/components/Admin.js